module.exports = __webpack_public_path__ + "static/img/guanc.5dffe90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tout/guanc.jpg
// module id = mvMl
// module chunks = 1